<template>
  <v-row justify="center" style="z-index: 999">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="500px"
      :retain-focus="false"
    >
      <v-card v-if="contact">
        <v-toolbar class="mb-4">
          <v-toolbar-title>
              <span v-if="contact.isPersonal" class="text-h5">{{ $t('contacts.btn.personalContacts') }}</span>
              <span v-else class="text-h5">{{ $t('contacts.btn.sharedContacts') }}</span>
          </v-toolbar-title>
          <template v-slot:extension>
            <v-tabs
              v-model="tabs"
            >
              <v-tabs-slider></v-tabs-slider>
              <v-tab class="primary--text">
                <v-icon>mdi-account-box</v-icon>
              </v-tab>

              <v-tab class="primary--text">
                <v-icon>mdi-domain</v-icon>
              </v-tab>

              <v-tab class="primary--text">
                <v-icon>mdi-map-marker</v-icon>
              </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
        <v-card-text>
          <v-form
            ref="form"
            data-testid="contacts-form"
            v-model="valid"
          >
            <ContactFormFields/>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="cancel()"
          >
            {{ $t('contacts.btn.cancel') }}
          </v-btn>
          <v-btn
            text
            color="primary"
            :disabled="!valid"
            data-testid="contacts-form-submit-btn"
            @click="submit()"
          >
            {{ isUpdate ? $t('contacts.btn.update') : $t('contacts.btn.create') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ContactFormFields from '@/components/contacts/forms/contact/index.vue'
export default {
  name: 'contacts-form',
  components: { ContactFormFields },
  data () {
    return {
      valid: false
    }
  },
  computed: {
    ...mapGetters({
      dialog: 'contacts/form/dialog',
      isUpdate: 'contacts/form/isUpdate',
      getContact: 'contacts/form/contact',
      getTabs: 'contacts/form/tabs'
    }),
    contact: { get () { return this.getContact }, set (contact) { this.setContact(contact) } },
    tabs: { get () { return this.getTabs }, set (tabs) { this.setTabs(tabs) } }
  },
  methods: {
    ...mapActions({
      create: 'contacts/create',
      update: 'contacts/update',
      setContact: 'contacts/form/setContact',
      close: 'contacts/form/close',
      setTabs: 'contacts/form/setTabs',
      removeEmptyEmails: 'contacts/form/removeEmptyEmails'
    }),

    async cancel () {
      await this.removeEmptyEmails()
      this.close()
    },

    submit () {
      if (this.isUpdate) {
        this.update(this.contact)
      } else {
        this.create(this.contact)
      }
      this.close()
    }
  }
}
</script>

<style>

</style>
